<template>
    <div>
        <div class="tuter_fotter">
                <div class="tuter_fotter_left">
                  <div class="text">
                      Показывать по 
                  </div>
                  <div class="choose_number_tuter" >
                    <div class="choose_number_tuter_block" @click="modalCountTuter()">
                      {{startCountTuterPage}}-{{countTuterPage}}
                      <svg class="svg" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.293 0.292969L5.99997 4.58597L1.70697 0.292969L0.292969 1.70697L5.99997 7.41397L11.707 1.70697L10.293 0.292969Z" fill="#C5C5C9"/>
                      </svg>
                    </div> 
                    <transition name="fade">
                      <div class="modal_block_choose_number" v-if="showModalCountTuter === true" @click="closeModalCountTuter()" @mouseleave="closeModalCountTuter()">
                        <div class="number" v-for="(item,i) in numberTuter" :key="i" @click="chooseModalCountTuter(i) ">{{item.start}}-{{item.finish}}</div>
                      </div>
                    </transition>
                  </div>
                  <div class="number_tuter">
                    из {{countTuter}}
                  </div>
                </div>
                <div class="tuter_fotter_right">
                   <div class="text">
                     <div>
                       стр
                     </div>
                     <div class="number_page">
                       {{numberPage}}
                     </div>
                     <div>
                       из {{countPage}}
                     </div>
                  </div>
                  <div class="arrow left" @click="transitionPageLeft()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.7477 4.33398L6.40479 10.0007L11.7477 15.6673L13.0715 14.2633L9.05235 10.0007L13.0715 5.73799L11.7477 4.33398Z" fill="#C5C5C9"/>
                      <transition name="fade">
                        <path d="M11.7477 4.33398L6.40479 10.0007L11.7477 15.6673L13.0715 14.2633L9.05235 10.0007L13.0715 5.73799L11.7477 4.33398Z" fill="#C5C5C9"/>
                        <path d="M11.7477 4.33398L6.40479 10.0007L11.7477 15.6673L13.0715 14.2633L9.05235 10.0007L13.0715 5.73799L11.7477 4.33398Z" fill="#8C71FE"/>
                      </transition>
                    </svg>
                  </div>
                  <div class="arrow" @click="transitionPageRight()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.51442 15.666L12.8573 9.99935L7.51442 4.33268L6.19063 5.73669L10.2097 9.99935L6.19063 14.262L7.51442 15.666Z" fill="#C5C5C9"/>
                    </svg>
                  </div>
                  <div>

                  </div>
                </div>
              </div>
    </div>
</template>

<script>
    export default {
        name:'footer',
        props:{
            
            arr:[Array],
            countTuterPage:[Number],
            countTuter:[Number],
            numberPage:[Number],
            countPage:[Number],
            startCountTuter:[Number],
            finishCountTuter:[Number]


        },
        data(){
            return{
                showModalCountTuter: false,
                arrow:false,
                arrow1:false,
                numberTuter:[],
                startCountTuterPage:1,
                number:0,
                t:true
                
            }
        },
        methods:{
            closeModalCountTuter(){
                this.showModalCountTuter = false
            },
            modalCountTuter(){
              if(this.t === true){
                let a = this.startCountTuterPage;
                let b = this.countTuterPage;
                for(let i = 0; i < this.arr.length; i++){
                  if(i % this.countTuterPage === 0){
                    let obj = {
                      "id": this.number,
                      "start":a,
                      "finish":b
                    };
                    this.numberTuter.push(obj)
                    a = a + this.countTuterPage
                    b = b + this.countTuterPage
                    if(b>this.arr.length){
                      b = this.arr.length
                    }
                    this.number++
                  }
                }
                this.t = false
              }
              
              this.showModalCountTuter = true
            },

            chooseModalCountTuter(i){
                this.startCountTuterPage = this.numberTuter[i].start
                this.countTuterPage = this.numberTuter[i].finish
                this.startCountTuter = 0
                this.finishCountTuter = this.countTuterPage
                this.countPage = Math.ceil(this.arr.length / this.countTuterPage)
                this.numberPage = 1
                this.$emit('changeCountTuter', this.startCountTuter, this.finishCountTuter, this.numberPage, this.countPage, this.countTuterPage)
                console.log(this.countPage, this.arr.length, this.countTuterPage)
            },

            transitionPageRight(){
            let x = 0

             if(this.numberPage < this.countPage){
                x = this.countTuterPage
                this.startCountTuter += x
                this.finishCountTuter += x
                this.numberPage++
            }

            this.$emit('startfinish', this.startCountTuter, this.finishCountTuter, this.numberPage)
            console.log(this.startCountTuter, this.finishCountTuter, this.numberPage)

          },
          transitionPageLeft(){
            let x = 0
             if(this.numberPage > 1){
                x = this.countTuterPage
                this.startCountTuter -= x
                this.finishCountTuter -= x
                this.numberPage--
            }
            this.$emit('finishstart', this.startCountTuter, this.finishCountTuter, this.numberPage)
            console.log(this.startCountTuter, this.finishCountTuter, this.numberPage)
          },
        },
        mounted() {
            

        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

  .fade-enter-active, .fade-leave-active {
      transition: opacity ease .5s;
  }
  .fade-enter, .fade-leave-to {
      opacity: 0;
  }

 .tuter_fotter{
    display: flex;
    justify-content: space-between;
    margin:16px 0 40px 0;
    .tuter_fotter_left{
      display: flex;
      align-items: center;


      .text{
        font-family: $font_Geometria;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        /* identical to box height */


        display: flex;
        align-items: center;

        /* Grey_2 */

        color: #ABABB2;
        padding-right:9px;
      }
      .choose_number_tuter{
        position: relative;



        .choose_number_tuter_block{
          font-family: $font_Geometria;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 18px;
          display: flex;
          align-items: center;
          color: #ABABB2;
          border: 1px solid #E2E2F6;
          box-sizing: border-box;
          border-radius: 4px ;
          padding:10px 13px 8px 13px;
          cursor: pointer;

         .svg{
            padding-left:5.72px;
          }
        }

        .modal_block_choose_number{
          position: absolute;
          width: 98px;

          bottom:0;
          right:0;
          background: #FFFFFF;
          border: 1px solid rgba(0, 0, 0, 0.08);
          box-sizing: border-box;
          box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
          border-radius: 8px;
          z-index: 20;
          padding: 2px 0 20px 0px;
          cursor: pointer;

          .number{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top:18px;
            font-family: $font_Geometria;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 140%;
            color: #333333;
            transition: 0.5s;
          }
          .number:hover{
            color: #8C71FE;
          }

         }

      }
      .number_tuter{
        font-family: $font_Geometria;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        color: #ABABB2;
        padding-left:9px;
      }
    }
    .tuter_fotter_right{
      display: flex;
      align-items: center;
      .text{
        display: flex;
        align-items: center;
        font-family: $font_Geometria;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #ABABB2;
        padding-right:28px;

        .number_page{
          border: 1px solid #E2E2F6;
          box-sizing: border-box;
          border-radius: 4px;
          padding: 8px 14px 8px 14px;
          margin:0 9px 0 9px;
        }


      }
      .arrow{
        display: flex;
        align-items: flex-end;
        border: 1px solid #F2F2F2;
        box-sizing: border-box;
        border-radius: 4px;
        padding:8px;
        margin-right:10px;
        cursor: pointer;
        transition: all 0.5s;

        svg path {
          transition: all 0.5s;
        }
      }
      .arrow:hover{
        border: 1px solid #8C71FE;

        svg path {
          fill: #8C71FE;
        }
      }
      .left{
        margin-right:10px;
      }
    }

    

}
</style>